const initialState = () => ({
  eventLogs: [],
})

const getters = {
  EVENT_LOGS: state => state.eventLogs,
}

const actions = {}

const mutations = {
  RESET_STATE (state, payload) {
    const s = initialState()
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },
  SET_EVENT_LOGS (state, payload) {
      state.eventLogs = payload
    },
}

export default {
  namespaced: true,
  state: initialState(),
  getters,
  actions,
  mutations,
}
